import { Injectable } from '@angular/core';
import { Location } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class ReturnUrlService {
  constructor(private location: Location) {}

  buildReturnUrl(configuredUrl: string | undefined, fallbackPath: string): string {
    const trimmedUrl = configuredUrl?.trim();
    if (trimmedUrl && this.isAbsoluteUrl(trimmedUrl)) {
      return trimmedUrl;
    }

    const path = this.normalizePath(trimmedUrl || fallbackPath);
    const preparedUrl = this.location.prepareExternalUrl(path);

    return this.ensureAbsoluteUrl(preparedUrl);
  }

  private normalizePath(path: string): string {
    if (!path) {
      return '/';
    }

    const withoutHashPrefix = path.startsWith('/#')
      ? path.substring(2)
      : path.startsWith('#')
        ? path.substring(1)
        : path;

    if (!withoutHashPrefix.startsWith('/')) {
      return `/${withoutHashPrefix}`;
    }

    return withoutHashPrefix;
  }

  private ensureAbsoluteUrl(url: string): string {
    if (this.isAbsoluteUrl(url) || typeof window === 'undefined') {
      return url;
    }

    const normalizedUrl = url.startsWith('/') ? url : `/${url}`;
    return `${window.location.origin}${normalizedUrl}`;
  }

  private isAbsoluteUrl(url: string): boolean {
    return /^https?:\/\//i.test(url);
  }
}
